import { createSelector } from "reselect";
import { RootState } from "../../rootReducer";

export const selectSignerDocuments = createSelector(
  [(store: RootState) => store.documentsSignerList.documents],
  (documents) => documents
);
